<template>
  <div class="table-wrapper">
    <table class="table">
      <thead>
      <tr>
        <td class="title">#</td>
        <td class="title">Date</td>
        <td class="title">Type</td>
        <td class="title">Amount</td>
        <td class="title">Status</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, i) in paginatedTransactions" :key="i">
        <td class="desc">{{ item.order_nr }}</td>
        <td class="desc">{{ formatDate(item.created_at) }}</td>
        <td class="desc">{{ type(item.payment_type) }}</td>
        <td class="desc">
            <span class="crypto desc">
              {{ crypto(item) }}
            </span>
          <br />
          <span
              :class="[
                'fiat desc',
                { plus: item.payment_type !== 'crypto', minus: item.payment_type === 'crypto' }
              ]"
          >
              {{ fiat(item) }}
            </span>
        </td>
        <td class="desc">
          {{ item.status }}
        </td>
      </tr>
      </tbody>
    </table>

    <div class="pagination">
      <div
          v-for="page in visiblePages"
          :key="page"
          @click="changePage(page)"
          :class="{ active: currentPage === page }"
      >
        {{ page }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TransactionsTable",
  async mounted() {
    await this.fetchTransactions();
  },
  props: {
    currencies: {
      type: Array,
      default: () => {}
    }
  },
  data: () => {
    return {
      transactions: [],
      perPage: 4,
      currentPage: 1
    };
  },
  computed: {
    paginatedTransactions() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.transactions.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.transactions.length / this.perPage);
    },
    visiblePages() {
      const maxPages = 4; // Максимальное число видимых страниц
      const pages = [];
      let start = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
      let end = Math.min(this.totalPages, start + maxPages - 1);

      // Если диапазон страниц смещён в конец
      if (end - start + 1 < maxPages) {
        start = Math.max(1, end - maxPages + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    }
  },
  methods: {
    async fetchTransactions() {
      try {
        const { data: { payload } } = await this.$http.get("orders/history");
        this.transactions = payload;
      } catch (e) {
        console.error(e);
      }
    },
    formatDate(timestampInSeconds) {
      const d = new Date(timestampInSeconds * 1000); // <--- УМНОЖАЕМ на 1000!

      if (isNaN(d.getTime())) {
        return 'Invalid date';
      }

      const day = d.getUTCDate().toString().padStart(2, '0');
      const month = d.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' });
      const year = d.getUTCFullYear();
      const hours = d.getUTCHours().toString().padStart(2, '0');
      const minutes = d.getUTCMinutes().toString().padStart(2, '0');

      return `${day} ${month} ${year} ${hours}:${minutes}`;
    }
    ,
    type(type) {
      switch (type) {
        case 'crypto':
          return 'Withdraw from wallet';
        default:
          return 'Top up';
      }
    },
    crypto({ payment_type, amount, source_asset, dest_amount, dest_asset }) {
      if (payment_type === 'crypto') {
        return `${amount} ${source_asset.toUpperCase()}`;
      }
      return `${dest_amount} ${dest_asset.toUpperCase()}`;
    },
    fiat({ payment_type, amount, source_asset, dest_amount, dest_asset }) {
      let currency;
      let finalAmount;
      let sign;

      if (payment_type === 'crypto') {
        currency = dest_asset.toUpperCase();
        finalAmount = dest_amount;
        sign = '-';
      } else {
        currency = source_asset.toUpperCase();
        finalAmount = amount;
        sign = '+';
      }

      // Убираем лишние нули
      finalAmount = parseFloat(finalAmount).toString();

      // Получаем символ валюты
      currency = this.currencies[currency] && this.currencies[currency].symbol ? this.currencies[currency].symbol : currency;

      return `${sign} ${currency}${finalAmount}`;
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    }
  }
};
</script>

<style scoped>
.table-wrapper {
  margin: 20px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.title {
  font-weight: bold;
  border-bottom: 2px solid #ccc;
  padding: 10px;
}

.desc {
  padding: 10px;
  text-align: left;
}

button {
  padding: 5px 10px;
  cursor: pointer;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  border-radius: 5px;
}

button.active {
  font-weight: bold;
  background-color: #007bff;
  color: white;
}

button:hover {
  background-color: #e0e0e0;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
